import React, { useContext, useState } from 'react'
import { IconCalendarPlus, IconSparkles } from '@tabler/icons-react'
import { Flex, Title, Text, Button, Group } from 'components'
import { useTranslation } from 'react-i18next'
import { LessonsContext } from 'components'
import { StepperContext } from '../../context/StepperContext'
import { AILessonsPlanningModal } from '../AILessonsPlanningModal'

interface LessonHeaderProps {
  onRefresh?: () => void
}

const LessonHeader = ({ onRefresh }: LessonHeaderProps): JSX.Element => {
  const { t } = useTranslation()
  const { handleAddLesson, lessons } = useContext(LessonsContext)
  const { projectId, aiContext } = useContext(StepperContext)
  const [aiModalOpened, setAIModalOpened] = useState(false)

  const handleAIGenerate = (data: any) => {
    if (onRefresh) {
      onRefresh()
    }
  }

  // Verifica se o usuário usou IA no Step 1
  const hasUsedAI = aiContext && aiContext.generatedData

  return (
    <>
      <Flex justify='space-between' align='center' mb='lg'>
        <Flex direction='column'>
          <Title order={2}>{t('new_project_page.title_planning')}</Title>
          <Text color='dimmed'>{t('new_project_page.description_planning')}</Text>
        </Flex>

        <Group spacing='sm'>
          {hasUsedAI && (
            <Button
              leftIcon={<IconSparkles size={18} />}
              variant='light'
              color='grape'
              size='sm'
              onClick={() => setAIModalOpened(true)}
            >
              {t('new_project_page.generate_with_ai')}
            </Button>
          )}

          {lessons.length > 0 && (
            <Button
              leftIcon={<IconCalendarPlus />}
              size='lg'
              variant='light'
              onClick={handleAddLesson}
            >
              {t('new_project_page.add_lesson')}
            </Button>
          )}
        </Group>
      </Flex>

      <AILessonsPlanningModal
        opened={aiModalOpened}
        onClose={() => setAIModalOpened(false)}
        projectId={projectId}
        onGenerate={handleAIGenerate}
      />
    </>
  )
}

export default LessonHeader
